import { default as about_45uswWoYXbZjPYMeta } from "/working_dir/pages/about-us.vue?macro=true";
import { default as loginPFf2hKcQIuMeta } from "/working_dir/pages/account/login.vue?macro=true";
import { default as signuptNlug6E4G8Meta } from "/working_dir/pages/account/signup.vue?macro=true";
import { default as virtual_45tryonPpDd2pTqN9Meta } from "/working_dir/pages/case-study/virtual-tryon.vue?macro=true";
import { default as contact_45usyg4ScjhdNKMeta } from "/working_dir/pages/contact-us.vue?macro=true";
import { default as generative_45aitXRgJYfHadMeta } from "/working_dir/pages/generative-ai.vue?macro=true";
import { default as indexBEEgJFKpn5Meta } from "/working_dir/pages/index.vue?macro=true";
import { default as servicesttviXAKUeBMeta } from "/working_dir/pages/services.vue?macro=true";
import { default as indexWHdleIDPHBMeta } from "/working_dir/pages/virtual-tryon/index.vue?macro=true";
import { default as indexOXzBol1sNUMeta } from "/working_dir/pages/virtual-tryon/live-demo/index.vue?macro=true";
export default [
  {
    name: about_45uswWoYXbZjPYMeta?.name ?? "about-us",
    path: about_45uswWoYXbZjPYMeta?.path ?? "/about-us",
    meta: about_45uswWoYXbZjPYMeta || {},
    alias: about_45uswWoYXbZjPYMeta?.alias || [],
    redirect: about_45uswWoYXbZjPYMeta?.redirect,
    component: () => import("/working_dir/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: loginPFf2hKcQIuMeta?.name ?? "account-login",
    path: loginPFf2hKcQIuMeta?.path ?? "/account/login",
    meta: loginPFf2hKcQIuMeta || {},
    alias: loginPFf2hKcQIuMeta?.alias || [],
    redirect: loginPFf2hKcQIuMeta?.redirect,
    component: () => import("/working_dir/pages/account/login.vue").then(m => m.default || m)
  },
  {
    name: signuptNlug6E4G8Meta?.name ?? "account-signup",
    path: signuptNlug6E4G8Meta?.path ?? "/account/signup",
    meta: signuptNlug6E4G8Meta || {},
    alias: signuptNlug6E4G8Meta?.alias || [],
    redirect: signuptNlug6E4G8Meta?.redirect,
    component: () => import("/working_dir/pages/account/signup.vue").then(m => m.default || m)
  },
  {
    name: virtual_45tryonPpDd2pTqN9Meta?.name ?? "case-study-virtual-tryon",
    path: virtual_45tryonPpDd2pTqN9Meta?.path ?? "/case-study/virtual-tryon",
    meta: virtual_45tryonPpDd2pTqN9Meta || {},
    alias: virtual_45tryonPpDd2pTqN9Meta?.alias || [],
    redirect: virtual_45tryonPpDd2pTqN9Meta?.redirect,
    component: () => import("/working_dir/pages/case-study/virtual-tryon.vue").then(m => m.default || m)
  },
  {
    name: contact_45usyg4ScjhdNKMeta?.name ?? "contact-us",
    path: contact_45usyg4ScjhdNKMeta?.path ?? "/contact-us",
    meta: contact_45usyg4ScjhdNKMeta || {},
    alias: contact_45usyg4ScjhdNKMeta?.alias || [],
    redirect: contact_45usyg4ScjhdNKMeta?.redirect,
    component: () => import("/working_dir/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: generative_45aitXRgJYfHadMeta?.name ?? "generative-ai",
    path: generative_45aitXRgJYfHadMeta?.path ?? "/generative-ai",
    meta: generative_45aitXRgJYfHadMeta || {},
    alias: generative_45aitXRgJYfHadMeta?.alias || [],
    redirect: generative_45aitXRgJYfHadMeta?.redirect,
    component: () => import("/working_dir/pages/generative-ai.vue").then(m => m.default || m)
  },
  {
    name: indexBEEgJFKpn5Meta?.name ?? "index",
    path: indexBEEgJFKpn5Meta?.path ?? "/",
    meta: indexBEEgJFKpn5Meta || {},
    alias: indexBEEgJFKpn5Meta?.alias || [],
    redirect: indexBEEgJFKpn5Meta?.redirect,
    component: () => import("/working_dir/pages/index.vue").then(m => m.default || m)
  },
  {
    name: servicesttviXAKUeBMeta?.name ?? "services",
    path: servicesttviXAKUeBMeta?.path ?? "/services",
    meta: servicesttviXAKUeBMeta || {},
    alias: servicesttviXAKUeBMeta?.alias || [],
    redirect: servicesttviXAKUeBMeta?.redirect,
    component: () => import("/working_dir/pages/services.vue").then(m => m.default || m)
  },
  {
    name: indexWHdleIDPHBMeta?.name ?? "virtual-tryon",
    path: indexWHdleIDPHBMeta?.path ?? "/virtual-tryon",
    meta: indexWHdleIDPHBMeta || {},
    alias: indexWHdleIDPHBMeta?.alias || [],
    redirect: indexWHdleIDPHBMeta?.redirect,
    component: () => import("/working_dir/pages/virtual-tryon/index.vue").then(m => m.default || m)
  },
  {
    name: indexOXzBol1sNUMeta?.name ?? "virtual-tryon-live-demo",
    path: indexOXzBol1sNUMeta?.path ?? "/virtual-tryon/live-demo",
    meta: indexOXzBol1sNUMeta || {},
    alias: indexOXzBol1sNUMeta?.alias || [],
    redirect: indexOXzBol1sNUMeta?.redirect,
    component: () => import("/working_dir/pages/virtual-tryon/live-demo/index.vue").then(m => m.default || m)
  }
]